import { paginationService } from 'core/services/paginationService';

export interface PermissionGroup {
	'@id': string;
	'@type': string;
	id: number;
	label: string;
}

export interface Permission {
	'@id': string;
	'@type': string;
	id: number;
	label: string;
	description: string | null;
	permissionGroup: PermissionGroup;
}

export interface GetPermissionsParams {
	page?: number;
	itemsPerPage?: number;
}

export interface PermissionsResponse {
	items: Permission[];
	total: number;
}

export const PERMISSION_FUNCTIONS = ['view', 'edit', 'delete', 'execute'];

/**
 * Get permissions with pagination
 */
export const getPermissions = async (
	params: GetPermissionsParams = {}
): Promise<PermissionsResponse> => {
	try {
		const { itemsPerPage = 50 } = params;
		const response = await paginationService.getWithHandler(
			'/permissions',
			undefined,
			itemsPerPage,
		);
		const permissionsData = response?.member || response?.['hydra:member'] || [];
		const total =
			response?.totalItems ?? response?.['hydra:totalItems'] ?? permissionsData.length;

		return { items: permissionsData, total };
	} catch (error: any) {
		console.error('Failed to fetch permissions:', error);
		return { items: [], total: 0 };
	}
};

// Export as service object
export const permissionsService = {
	getPermissions,
};

export default permissionsService;
